import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects';
import { CheckoutStatus, DeliveryOptionsEnum, RoutePathname, } from '@as-react/common-types';
import CheckoutAPI from '../../../api/CheckoutAPI';
import BuyAPI from '../../../api/buy/BuyAPI';
import CustomerApi from '../../../api/customer/CustomerApi';
import { CheckoutActionTypes } from '../../../enums/ActionEnums';
import checkoutActions from '../actions/CheckoutActions.creators';
import { analyticsActions } from '../../analytics/actions/AnalyticsActions.creators';
import { getQuerystringByName } from '../../../util/URLParamUtil';
import ProductDetailAPI from '../../../api/ProductDetailAPI';
import ReevooUtil from '../../../util/ReevooUtil';
import { makeGetLoggedInState } from '../../session/selectors/SessionSelector';
import MonetateUtil from '../../../util/MonetateUtil';
import { isAxiosError } from 'axios';
export function* initCheckoutSaga() {
    yield takeLatest(CheckoutActionTypes.INIT, initCheckout);
}
export const getCheckoutState = (state) => state.checkout.state;
export function* initCheckout(action) {
    var _a;
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const currentCheckoutState = yield select(getCheckoutState);
        const loggedIn = yield select(makeGetLoggedInState());
        const hrefCheckout = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.hrefCheckout;
        if (currentCheckoutState === CheckoutStatus.INITIALIZING) {
            const checkoutInitData = yield call(CheckoutAPI.initRequest, servicesEndpoint, defaultRequestParams);
            yield put(checkoutActions.createInitSetAction(checkoutInitData));
            if (checkoutInitData.readyForCheckout) {
                window.location.href = loggedIn ? `${hrefCheckout}/${RoutePathname.DELIVERY}` : hrefCheckout;
            }
        }
    }
    catch (_b) {
        yield put(checkoutActions.createErrorAction());
    }
}
export function* analyticsLoginCheckoutSaga() {
    yield takeLatest(CheckoutActionTypes.LOGIN_ANALYTICS, analyticsLoginCheckout);
}
export function* analyticsLoginCheckout() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const analyticsAdobeTagManagerData = yield call(CheckoutAPI.checkoutStepDtm, servicesEndpoint, defaultRequestParams);
        yield put(checkoutActions.createAnalyticsSuccessAction(analyticsAdobeTagManagerData));
    }
    catch (_a) { }
}
export function* orderConfirmationSaga() {
    yield takeLatest(CheckoutActionTypes.GET_CONFIRMATION_ORDER, orderConfirmation);
}
export function* orderConfirmation() {
    try {
        const aemConfigurationContext = yield getContext('aemConfiguration');
        const { currency, servicesEndpoint, defaultRequestParams } = aemConfigurationContext;
        const orderId = getQuerystringByName(window.location.search, 'orderID');
        yield put(checkoutActions.createAnalyticsConfirmationPageAction());
        const order = yield call(BuyAPI.getConfirmedOrder, servicesEndpoint, defaultRequestParams, orderId);
        const newsletterPreferences = yield call(CustomerApi.getNewsletterPreferences, servicesEndpoint, defaultRequestParams, order.customerUUID);
        if (newsletterPreferences.newCustomer) {
            const profile_details = {
                email_newsletter: true,
            };
            yield call(CustomerApi.updatePreferences, servicesEndpoint, defaultRequestParams, profile_details, order.contactPerson);
        }
        const mappedProducts = yield all(order.products.map(product => call(ProductDetailAPI.fetchProductForConfirmation, aemConfigurationContext.servicesApi, aemConfigurationContext.servicesApiPrefixAemServices, aemConfigurationContext.mainWebShop, aemConfigurationContext.fictiveWebShop, aemConfigurationContext.lang, product)));
        yield put(checkoutActions.createSetConfirmationOrderAction(Object.assign(Object.assign({}, order), { mappedProducts })));
        yield put(checkoutActions.createSetNewsletterPreferencesAction(newsletterPreferences));
        yield put(checkoutActions.createSetConfirmationOrderErrorAction(null));
        yield put(checkoutActions.createSetConfirmationIsCollectStoreAction(order.deliveryOption === DeliveryOptionsEnum.COLLECT_STORE));
        ReevooUtil.setReevooTracking(order);
        MonetateUtil.pushOrderConfirmationEvent(mappedProducts, currency, orderId);
    }
    catch (error) {
        if (isAxiosError(error)) {
            yield put(checkoutActions.createSetConfirmationOrderErrorAction(error.message));
        }
    }
}
export function* analyticsConfirmationPageSaga() {
    yield takeLatest(CheckoutActionTypes.ANALYTICS_CONFIRMATION_PAGE_STEP, analyticsConfirmationPage);
}
export function* analyticsConfirmationPage() {
    try {
        const { servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
        const orderId = getQuerystringByName(window.location.search, 'orderID');
        const purchaseStepInformation = yield call(BuyAPI.getAnalyticsPurchaseStepInformation, servicesEndpoint, defaultRequestParams, orderId);
        const dtmPurchaseStepInformation = yield call(BuyAPI.getDtmAnalyticsPurchaseStepInformation, servicesEndpoint, defaultRequestParams, orderId);
        yield put(analyticsActions.confirmationPage());
        if (purchaseStepInformation) {
            yield put(checkoutActions.createAnalyticsMergeConfirmationPageAction(dtmPurchaseStepInformation));
            yield put(analyticsActions.googleConfirmationPage(purchaseStepInformation));
        }
    }
    catch (_a) { }
}
export default function* checkoutSaga() {
    yield all([
        initCheckoutSaga(),
        analyticsLoginCheckoutSaga(),
        orderConfirmationSaga(),
        analyticsConfirmationPageSaga(),
    ]);
}
